export enum ClaimPartyMinLengths {
  ContactPhone = 7,
  ContactFax = 7,
}
